var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 3.84858C15.0029 4.04744 15.0641 4.24105 15.1759 4.40557C15.2876 4.5701 15.4451 4.69836 15.6288 4.77458C17.271 5.49716 18.6598 6.69408 19.6168 8.21168C20.5738 9.72928 21.0554 11.4983 20.9998 13.2916C20.961 15.6785 19.9757 17.9523 18.2605 19.6128C16.5453 21.2732 14.2407 22.1843 11.8538 22.1456C9.46682 22.1069 7.19302 21.1215 5.53257 19.4063C3.87212 17.6911 2.96105 15.3865 2.99977 12.9996C3.00208 11.2558 3.51091 9.55025 4.46442 8.09026C5.41792 6.63026 6.77503 5.47871 8.37077 4.77558C8.55456 4.6989 8.71197 4.57026 8.8237 4.40541C8.93544 4.24057 8.99663 4.0467 8.99977 3.84758C9.00002 3.68379 8.96005 3.52244 8.88335 3.37772C8.80664 3.233 8.69557 3.10933 8.55988 3.01759C8.4242 2.92585 8.26805 2.86884 8.10517 2.85158C7.9423 2.83431 7.77767 2.85732 7.62577 2.91858C5.30505 3.92472 3.40199 5.69992 2.23713 7.94517C1.07227 10.1904 0.716795 12.7685 1.23058 15.2452C1.74436 17.7219 3.096 19.9459 5.05784 21.5425C7.01968 23.1392 9.47183 24.0109 12.0013 24.0109C14.5307 24.0109 16.9829 23.1392 18.9447 21.5425C20.9065 19.9459 22.2582 17.7219 22.772 15.2452C23.2857 12.7685 22.9303 10.1904 21.7654 7.94517C20.6005 5.69992 18.6975 3.92472 16.3768 2.91858C16.2246 2.85665 16.0596 2.83316 15.8962 2.85016C15.7329 2.86717 15.5762 2.92416 15.4401 3.01609C15.304 3.10802 15.1926 3.23206 15.1158 3.37726C15.039 3.52245 14.9991 3.68433 14.9998 3.84858Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 1C13.0002 0.447715 12.5524 0 12.0002 0C11.4479 0 11.0002 0.447715 11.0002 1V7C11.0002 7.55228 11.4479 8 12.0002 8C12.5524 8 13.0002 7.55228 13.0002 7V1Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.46fd7964d8fd9c887f5a74d11eb6eb5b.svg";
export { ForwardRef as ReactComponent };